// @ts-expect-error ts-migrate(2614) FIXME: Module '"react-linkify"' has no exported member 'l... Remove this comment to see the full error message
import Linkify, { linkify } from "react-linkify";
// NOTE: this modifies the global state for `linkify` - the library that
// this component uses internally to decide how to link things.
// Disable "mailto" links when rendering links
linkify.add("mailto:", null);
export default Linkify;
